module.exports = __webpack_public_path__ + "static/media/1f4e6.7a3329c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f4e6.svg
// module id = 640
// module chunks = 1